import * as actionTypes from "../Actions/actionTypes";

const initialState = {
  files: [],
  totalFiles: 0,
  totalPages: 0,
  currentPage: 0,
  pageSize: 20,
  stats: {
    totalFiles: 0,
    totalSize: 0,
    fileTypeBreakdown: {},
  },
  uploadProgress: 0,
  isUploading: false,
  isLoading: false,
  error: null,
  success: null,
  selectedFile: null,
  filters: {
    fileType: null,
    sortBy: "uploadedAt",
    sortDirection: "DESC",
  },
};

const FileManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        isUploading: false,
        uploadProgress: 100,
        error: null,
        success: "File uploaded successfully",
      };
    case actionTypes.FILE_UPLOAD_ERROR:
      return {
        ...state,
        isUploading: false,
        uploadProgress: 0,
        error: action.error,
        success: null,
      };

    // File List
    case actionTypes.FILE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actionTypes.FILE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        files: action.payload.data.files || [],
        totalFiles: action.payload.data.totalFileCount || 0,
        totalPages: action.payload.data.totalPages || 0,
        currentPage: action.payload.data.currentPage || 0,
        pageSize: action.payload.data.pageSize || 20,
        error: null,
      };
    case actionTypes.FILE_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        files: [],
      };

    // File Download
    case actionTypes.FILE_DOWNLOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actionTypes.FILE_DOWNLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        success: "File downloaded successfully",
      };
    case actionTypes.FILE_DOWNLOAD_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    // File Delete
    case actionTypes.FILE_DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actionTypes.FILE_DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        success: "File deleted successfully",
        files: state.files.filter((file) => file.id !== action.fileId),
        totalFiles: state.totalFiles - 1,
      };
    case actionTypes.FILE_DELETE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    // File Stats
    case actionTypes.FILE_STATS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case actionTypes.FILE_STATS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        stats: action.response,
        error: null,
      };
    case actionTypes.FILE_STATS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    // Clear state
    case actionTypes.CLEAR_FILE_MANAGEMENT_STATE:
      return {
        ...initialState,
      };

    // Reset messages
    case actionTypes.RESET:
      return {
        ...state,
        error: null,
        success: null,
      };

    default:
      return state;
  }
};

export default FileManagementReducer;
